<template>
  <div class="news flex fd-c ai-c">
      <div class="news-item flex fd-c ai-c" v-for="(item, index) in list" :key="index">
          <div class="t1 flex fd-c ai-c"
          v-html="item.info"></div>
      </div>
  </div>
</template>

<script>
import { findNews } from '../../../api'
export default {
  components:{},
  props:{},
  data(){
    return {
        list: []
    }
  },
  watch:{},
  computed:{},
  methods:{
      findNews() {
          findNews({
            page: 1,
            limit: 100,
          }).then(res=>{
              var list = res.data.data.records
              for (var item of list) {
                    var dataArr = item.info.split('<p')
                    var str = ''
                    for (var i in dataArr) {
                        if (i==0) {
                            continue;
                        }
                        if (dataArr[i].indexOf('class="') == -1) {
                            dataArr[i] = ` data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown"` + dataArr[i]
                        } else {
                            dataArr[i] = dataArr[i].replace('class="', `data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown `);
                        }
                        str += '<p' + dataArr[i]
                    }
                    item.info = str
              }
              this.list = list
              this.$nextTick(()=>{
                  this.$wow('listWOW')
              })
          })
      }
  },
  created(){
      this.findNews()
  },
  mounted(){}
}
</script>
<style scoped>
.news{
    width: 683px;
    margin: 105px auto 0;
}
.news-item{
    margin-bottom: 50px;
    cursor: pointer;
}
.news-item .t1>>>*{
    font-size: 14px;
    font-family: KhmerSangamMN;
    font-weight: 400;
    color: #93278F;
    line-height: 16px;
    text-align: center;
}
.news-item .t1>>>p:last-child{
    width:fit-content;
    border-bottom: 1px solid rgba(228, 201, 227, 1);
}
/* .news-item .t1>>>p:last-child a{
    line-height: 14px;
} */
</style>